import React from 'react';
import SMStream from 'dash-front/components/sm/streams/SMStream2';
import _ from 'lodash';
import { connect } from 'react-redux';

let widgets = ['LineupListSMWidget', 'LineupPitchSMWidget'];

class EventSMB extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount = () => {};

    state = {};

    renderLineupNotAwailableYet = () => (
        <div>
            <h1>Lineup is not awailable yet</h1>
            <p>Normally expected lineup appers 1 day before and CONFIRMED 1h-30m before match start</p>
        </div>
    );

    render() {
        const user = this.context.user;
        let {
            event,
            params: { eventId, tournamentId }
        } = this.props;

        let hasLinuep = _.get(event, 'properties.hasLineup', false);

        let hasLinuepConfirmed = _.get(event, 'properties.lineupConfirmed') === 'yes';

        return (
            <div>
                {hasLinuep && (
                    <SMStream
                        key={'inf_' + eventId}
                        smWidgets={widgets.map(name => ({
                            name,
                            props: { eventId, team: 'home', teamId: event.homeId }
                        }))}
                        title="HOME"
                    />
                )}

                {hasLinuep && (
                    <SMStream
                        key={'inf_away_' + eventId}
                        smWidgets={widgets.map(name => ({
                            name,
                            props: { eventId, team: 'away', teamId: event.awayId }
                        }))}
                        title="AWAY"
                    />
                )}
                {!hasLinuep && this.renderLineupNotAwailableYet()}
                <SMStream
                    key={'inf_squad_' + eventId}
                    smWidgets={[event.homeId, event.awayId].map(teamId => ({
                        name: 'TeamSquadListSMWidget',
                        groupTitle: ``,
                        groupKey: `${teamId}-1`,
                        props: { teamId }
                    }))}
                    title="Team Squads"
                />
            </div>
        );
    }
}

export default connect(state => ({ event: state.smBrowser.event }))(EventSMB);



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/event/EventLineupSMB.js
 **/